import { Client } from "../domain/clients";
import { clientStore } from "../infrastructure/store/clientStore";

export const getClientSession = {
  execute(): Client | null {
    return clientStore().isEmpty.value ? null : clientStore().memoryClient;
  },
};
